import React, { useEffect, useRef, useState } from "react";
import ModalWindow from "../UI/ModalWindow";
import RollNumberModal from "./RollNumberModal";
import RegistrationNumberModal from "./EditRegistrationNumberModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";

const StudentTableRow = ({
  student,
  refetchStudents,
  toggleMenu,
  menuRowId,
  setMenuRowId,
  setStudentsData,
}) => {
  const [rollNumberModal, setRollNumberModal] = useState(false);
  const [registrationNumberModal, setRegistrationNumberModal] = useState(false);
  const menuRef = useRef(null);

  const handleSelectStudent = (e) => {
    const { checked } = e.target;
    setStudentsData((prev) => {
      const updated = prev?.map((item) =>
        item?.admissionId === student?.admissionId
          ? { ...item, checked: checked }
          : item,
      );

      return updated;
    });
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuRowId(null);
      }
    };

    if (menuRowId === student.admissionId) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRowId, student.admissionId]);

  return (
    <tr key={student.admissionId}>
      <td>
        <input
          style={{ accentColor: "#126696" }}
          type="checkbox"
          checked={student?.checked || false}
          onChange={handleSelectStudent}
          className="form-control"
          name="selectStudent"
          id="selectStudent"
        />
      </td>
      <td>
        <a
          className="table-link"
          href={`/profile/${student?.peopleDetail?.username}`}
        >
          {student?.peopleDetail?.fullName}
        </a>
      </td>
      <td>{student?.roll ?? "N/A"}</td>
      <td>{student?.registrationNumber ?? "N/A"}</td>
      <td>{student?.peopleDetail?.gender}</td>
      <td>{student?.yearLevel?.name ?? "Unassigned"}</td>
      <td>{student?.classRoom?.name ?? "Unassigned"}</td>
      <td className={"address"}>
        {student?.peopleDetail?.customDetails?.streetAddress ?? "N/A"}
      </td>
      <td>
        <div
          ref={menuRef}
          className="flex menu-container table-menu"
          style={{ gap: "10px" }}
        >
          <button
            className="menu-btn"
            onClick={() => toggleMenu(student?.admissionId)}
          >
            <FontAwesomeIcon fontSize={16} icon={faEllipsisV} />
          </button>

          {menuRowId === student.admissionId && (
            <div className="menu">
              <button
                onClick={() => setRegistrationNumberModal((prev) => !prev)}
                className="edit-roll-btn"
              >
                Edit Registration Number
              </button>
              <button
                onClick={() => setRollNumberModal((prev) => !prev)}
                className="edit-roll-btn"
              >
                Edit Roll Number
              </button>
            </div>
          )}
        </div>

        <ModalWindow
          modal={rollNumberModal}
          modalHeader={"Update Student Details"}
          toggleModal={() => setRollNumberModal((prev) => !prev)}
          modalBody={
            <RollNumberModal
              refetchStudents={refetchStudents}
              setRollNumberModal={setRollNumberModal}
              student={student}
            />
          }
        />

        <ModalWindow
          modal={registrationNumberModal}
          modalHeader={"Update Student Details"}
          toggleModal={() => setRegistrationNumberModal((prev) => !prev)}
          modalBody={
            <RegistrationNumberModal
              refetchStudents={refetchStudents}
              student={student}
              setRegistrationNumberModal={setRegistrationNumberModal}
            />
          }
        />
      </td>
    </tr>
  );
};

export default StudentTableRow;
